import { css } from '@emotion/react';

import { charcoalGrey, pinkishOrange, steelGrey } from '../styled-variables';

export const typeHeading1 = css`
  text-transform: uppercase;
  font-size: 2rem;
  letter-spacing: 2.2px;
  line-height: 1.4;
  font-weight: 600;
`;

export const typeHeading2 = css`
  text-transform: uppercase;
  font-size: 0.75rem;
  letter-spacing: 2.3px;
  font-weight: 500;
`;

export const typeHeading3 = css`
  text-transform: uppercase;
  font-size: 1.125rem;
  line-height: 1.56;
  letter-spacing: 2px;
  font-weight: 600;
`;

export const typeMobileHeading1 = css`
  text-transform: uppercase;
  font-size: 1.5rem;
  font-weight: 600;
  letter-spacing: 5px;
`;

export const typeMobileHeading2 = css`
  text-transform: uppercase;
  font-size: 1.125rem;
  font-weight: 600;
  line-height: 1.44;
  letter-spacing: 2.3px;
`;

export const typeMobileHeading3 = css`
  text-transform: uppercase;
  font-size: 0.8125rem;
  font-weight: 600;
  letter-spacing: 1.3px;
`;

export const typeMobileHeading4 = css`
  font-size: 0.75rem;
  font-weight: 600;
  letter-spacing: 1px;
`;

export const typeParagraph2 = css`
  font-size: 0.875rem;
  line-height: 1.71;
`;

export const typeMobileParagraph1 = css`
  font-size: 1rem;
  font-weight: 500;
  line-height: 1.75;
  letter-spacing: 0;
`;

export const typeMobileParagraph2 = css`
  font-size: 1rem;
  line-height: 1.75;
`;

export const typeMobileParagraph3 = css`
  font-size: 1rem;
  line-height: 1.38;
  letter-spacing: 0.5px;
`;

export const typeMobileParagraph4 = css`
  font-size: 0.875rem;
  line-height: 1.57;
  letter-spacing: 0.2px;
`;

export const typeCardTag = css`
  text-transform: uppercase;
  font-size: 0.75rem;
  letter-spacing: 1px;
`;

export const typeTestimonialTitle = css`
  font-size: 1.125rem;
  line-height: 1.56;
  letter-spacing: 2.2px;
  text-transform: uppercase;
  font-weight: 600;
`;

export const typeTestimonialDescription = css`
  font-size: 1rem;
  line-height: 1.4;
`;

export const typeCourseCardCategory = css`
  font-size: 0.625rem;
  color: #27292d;
  text-transform: uppercase;
  font-weight: 600;
  letter-spacing: 0.6px;
  line-height: 1rem;
`;

export const typeCourseCardTitle = css`
  font-size: 1.25rem;
  line-height: 1.4;
  font-weight: 500;
`;

export const typeCourseCardAuthor = css`
  font-size: 0.875rem;
  line-height: 1.71;
`;

export const typeCourseCardFooter = css`
  font-size: 0.75rem;
  text-transform: uppercase;
  font-weight: 600;
  letter-spacing: 1.2px;
`;

export const typeTeacherCardName = css`
  font-size: 1.25rem;
  font-weight: 500;
`;

export const typeTeacherCardClass = css`
  font-size: 0.875rem;
  text-transform: uppercase;
  letter-spacing: 0.6px;
`;

export const typeNavigationCategory = css`
  font-size: 0.6875rem;
  text-transform: uppercase;
  font-weight: 200;
  letter-spacing: 0.25px;
`;

export const typeNavigationPage = css`
  font-size: 0.875rem;
  line-height: 1.41;
`;

export const typeInputPlaceholder = css`
  font-size: 1rem;
  font-weight: 500;
  line-height: 1.5;
`;

export const typeVideoOverlaySubheading = css`
  font-size: 1.25rem;
  font-weight: 500;
  line-height: 1.4;
  letter-spacing: -0.5px;
`;

// type-subscribe-heading was declared twice in the same .scss file
// export const typeSubscribeHeading = css`
//     font-size: 2rem;
//     line-height: 1.2;
//     letter-spacing: 0.1px;
// `;

export const typeFeaturedTeacherName = css`
  font-size: 1.125rem;
  font-weight: 500;
  line-height: 1.5;
`;

export const typeFeaturedTeacherStyle = css`
  font-size: 0.75rem;
  font-weight: 600;
  letter-spacing: 1px;
  color: ${steelGrey};
  text-transform: uppercase;
`;

export const typeAboutCourseDescription = css`
  font-size: 1rem;
  line-height: 1.75;
  color: ${steelGrey};
`;

export const typeCoursePreviewOutlineTitle = css`
  font-size: 1.25rem;
  font-weight: 600;
  letter-spacing: 1px;
  color: ${charcoalGrey};
  margin: 64px 0 26px;
`;

export const typeCourseOutlineSectionTitle = css`
  font-size: 1.625rem;
  font-weight: 500;
  line-height: 1.27;
  letter-spacing: 0.5px;
  color: ${charcoalGrey};
`;

export const typeYgiLearnCardTitle = css`
  font-size: 1.625rem;
  font-weight: 500;
  line-height: 1.31;
  color: ${charcoalGrey};
`;

export const typeYgiLearnCardDescription = css`
  font-size: 1.125rem;
  line-height: 1.5;
  color: ${steelGrey};
`;

export const typeYgiLoginLabel = css`
  font-size: 1rem;
  font-weight: normal;
  line-height: 1.25;
`;

export const typeYgiCreateAccountSocialBtn = css`
  font-size: 0.875rem;
  font-weight: 500;
  letter-spacing: 0.2px;
`;

export const typeYgiCreateAccountDivider = css`
  font-size: 0.6875rem;
  font-weight: 600;
  letter-spacing: 1.8px;
  text-transform: uppercase;
`;

export const typeYgiOrderItemTitle = css`
  font-size: 1rem;
  line-height: 1.75;
  letter-spacing: 0.3px;
`;

export const typeDropdownSearch = css`
  font-size: 1rem;
  line-height: 1.5;
  font-weight: 500;
`;

export const typeMegaSubLinkHeading = css`
  font-size: 0.8675rem;
  font-weight: 600;
  line-height: 2.55;
  letter-spacing: 1px;
`;

export const typeFeaturedArticleHeading = css`
  font-size: 2.5rem;
  font-weight: 500;
  line-height: 1.38;
  letter-spacing: -0.5px;
`;

export const typeFeaturedArticleHeadingSm = css`
  text-transform: uppercase;
  font-size: 1.5rem;
  font-weight: 600;
  line-height: 1.38;
  letter-spacing: 5px;
`;

export const typeHeroBannerHeading2 = css`
  font-size: 2.5rem;
  line-height: 1.3;
  letter-spacing: 0.1px;
  text-transform: none;
  font-weight: unset;
`;

export const typeLearnCardCtaTitle = css`
  font-size: 1.625rem;
  font-weight: 600;
  line-height: 1.27;
  letter-spacing: -0.4px;
`;

export const typeLearnCardCtaSubtitle = css`
  font-size: 1.375rem;
  line-height: 1.45;
`;

export const typeCourseDetailsSubsection = css`
  font-size: 0.75rem;
  font-weight: 500;
  line-height: 1.33;
  letter-spacing: 0.2px;
  color: ${steelGrey};
`;

export const typeFormInputError = css`
  font-size: 0.6875rem;
  color: #d0011b;
  line-height: 1.27;
`;

export const onboardingHeadingMobile = css`
  font-size: 1rem;
  line-height: 1.63;
  font-weight: 500;
`;

export const typeSubscribeHeading = css`
  font-size: 2.5rem;
  font-weight: normal;
  line-height: 1.2;
  letter-spacing: 0.1px;
`;

export const typeLearnArticleSubheading = css`
  font-size: 1.125rem;
  font-weight: 500;
  line-height: 1.56;
  color: ${charcoalGrey};
`;

export const typeLearnArticleQuote = css`
  font-size: 1rem;
  font-weight: 600;
  line-height: 1.5;
  color: ${pinkishOrange};
  text-align: center;
`;
